module.exports = __webpack_public_path__ + "img/radius.796db2da.png";